import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

export interface BreadcrumbItem {
  label: string;
  route?: string;
  active?: boolean;
}

@Component({
  selector: 'app-breadcrumb-with-back',
  templateUrl: './breadcrumb-with-back.component.html',
  styleUrls: ['./breadcrumb-with-back.component.scss']
})
export class BreadcrumbWithBackComponent {
  @Input() items: BreadcrumbItem[] = [];
  @Input() showBackButton: boolean = true;
  @Input() backRoute?: string;
  @Input() backLabel: string = 'Atrás';
  @Input() backIcon: string = 'pi pi-arrow-left';
  
  @Output() onBackClick = new EventEmitter<void>();

  constructor(private router: Router) {}

  navigateTo(item: BreadcrumbItem): void {
    if (item.route && !item.active) {
      this.router.navigate([item.route]);
    }
  }

  goBack(): void {
    this.onBackClick.emit();
    
    if (this.backRoute) {
      this.router.navigate([this.backRoute]);
    } else {
      // Usar historial del navegador
      window.history.back();
    }
  }
} 